import React from 'react';
import PropTypes from 'prop-types';
import ClassSummary from '../shared/ClassSummary/ClassSummary';
import './FeatureReportExpress.scss';
import PerformanceExpressRow from './PerformanceExpressRow/PerformanceExpressRow';
import PeriodsColumn from './PeriodsColumnExpress/PeriodsColumnExpress';
import { generateReactKey } from '../../../utils/shared/commonUtils';

const FeatureReportExpress = ({
    totalStudentCount,
    performanceTables,
    isSummary,
    infoSummary,
    assessedStudents,
}) => (
    <div className="class-performance-express">
        <ClassSummary
            infoSummary={infoSummary}
            totalStudentCount={totalStudentCount}
            isSummary={isSummary}
            assessedStudents={assessedStudents}
        />
        <div className={`feature-report-tables-express ${isSummary && 'table-row'}`}>
            {isSummary && <PeriodsColumn />}
            {performanceTables.map(
                (
                    { skillName, skillTitle, levelTitles, performanceRows, levelTypeTitle },
                    index,
                ) => (
                    <div key={generateReactKey(index, skillName)} className="table-container">
                        <div className="skill-name-express">
                            {skillName} <span className="skill-name-reduced">{skillTitle}</span>
                        </div>
                        <div className="performance-table-express">
                            {Object.keys(performanceRows).map((level, rowIndex) => {
                                const additionalKey = `${skillName}-${level}`;
                                return (
                                    <PerformanceExpressRow
                                        key={generateReactKey(rowIndex, additionalKey)}
                                        level={level}
                                        levelTitle={
                                            levelTitles[level] ? levelTitles[level] : levelTypeTitle
                                        }
                                        performance={performanceRows[level]}
                                    />
                                );
                            })}
                        </div>
                    </div>
                ),
            )}
        </div>
    </div>
);

FeatureReportExpress.defaultProps = {
    performanceTables: [],
    totalStudentCount: 0,
    isSummary: false,
    infoSummary: {},
    assessedStudents: {},
};

FeatureReportExpress.propTypes = {
    performanceTables: PropTypes.arrayOf(PropTypes.object),
    infoSummary: PropTypes.object,
    totalStudentCount: PropTypes.number,
    isSummary: PropTypes.bool,
    assessedStudents: PropTypes.object,
};

export default FeatureReportExpress;
